/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from '../ProgressBar/ProgressBar';

import Highlighter from 'react-highlight-words';

import Modal from './CustomModal';
import SelectDropDown from './Select';
import Svg from '../../../styles/components/widgets/Svg/Svg';

import AutoSearch from './AutoSearch';
import Spinner from '../shareModal/spinner';

import axiosClient from "../../../_helpers/http.helper";
import config from "../../../config";
import {formatUrl} from "../../../_helpers/urlFormat.helper";
import * as EmailValidator from 'email-validator';


class ShareComponent extends React.Component {
    static get propTypes () {
        return {
            collection: PropTypes.object.isRequired,
            course: PropTypes.object,
            isOpen: PropTypes.bool.isRequired,
            user: PropTypes.object.isRequired,
            isDefaultOptionTOC: PropTypes.bool,
            checkTOCDownload: PropTypes.func,
            checkTitleDownload: PropTypes.func,
            checkCoverDownload: PropTypes.func,
            close: PropTypes.func.isRequired,
            shareCollection: PropTypes.func.isRequired,
        };
    }

    static get defaultProps () {
        return {
            user: {}
        };
    }

    constructor (props) {
        super(props);
        this.shareableOptions = [
            {value: 'COMPLETE', label: 'Entire Collection'},
            {value: 'TOC', label: 'Cover & Table of Contents'}];
        this.dataForSpinner = {
            text: {
                chipText: 'Loading...'
            }
        };
        this.filterResults = this.filterResults.bind(this);
        this.shareContextChange = this.shareContextChange.bind(this);
        this.resetSharedUsersState = this.resetSharedUsersState.bind(this);
        this.getTOCDownloadPdf = this.getTOCDownloadPdf.bind(this);
        this.fetchTOCPageLink = this.fetchTOCPageLink.bind(this);
        this.getTitleDownloadPdf = this.getTitleDownloadPdf.bind(this);
        this.fetchTitlePageLink = this.fetchTitlePageLink.bind(this);
        this.getCoverDownloadPdf = this.getCoverDownloadPdf.bind(this);
        this.fetchCoverPageLink = this.fetchCoverPageLink.bind(this);
        this.getSearchUrl = this.getSearchUrl.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.fetchingSharedUsersAndCreator = this.fetchingSharedUsersAndCreator.bind(this);
        this.TOCRef = React.createRef();
        this.titleRef = React.createRef();
        this.coverRef = React.createRef();
        this.state = {
            titleProgressBarValue: 0,
            tocProgressBarValue: 0,
            coverProgressBarValue: 0,
            showCoverProgressBar: false,
            showTOCProgressBar: false,
            showTitleProgressBar: false,
            coverPageUrl: '',
            tocPageUrl: '',
            titlePageUrl: '',
            mergedCoverUrl: '',
            suggestions: [],
            sharedEmails: [],
            sharedUsers: [],
            userEmailsToBeShared: [],
            usersToBeShared: [],
            showTOCDownloadBtn: true,
            showTitleDownloadBtn: true,
            showCoverDownloadBtn: true,
            isSharedUsersBeingFetched: false,
            collectionCreator: undefined,
            sharedUsersCount: 0,
            sharedEmailCount: 0,
            mergedCoverPDfEpsUrl: '',
            tocPagePdfEpsUrl: '',
            titlePageEpsPdfUrl: ''
        };
    }


    componentDidMount () {
        this.setState({selected: this.shareableOptions[0]});
    }

    getSearchUrl() {
        return formatUrl(config.identity.baseUrl, config.identity.routes.users, {         
            geoId: this.props.collection.geo.id,
            unscrubbed: this.props.collection.unscrubbed,
            roles: ['INSTRUCTOR'],
            resultCount: 8
        });
    }

    renderSuggestion(value, option) {
        const highlightedText = <Highlighter
            highlightStyle={{fontWeight: 'bold', backgroundColor: 'transparent'}}
            searchWords={[value]}
            textToHighlight={' (' + option.username + ')'}
        />;
        return <div>{option.firstName + ' ' + option.lastName + ' '}<span
            style={{fontStyle: 'italic'}}> {option.username ? highlightedText : null}</span></div>;
    }

    shareContextChange (evt) {
        this.setState({selected: evt});
    }

    addSharedUser (suggestion) {
        if(this.state.usersToBeShared.find(user => user.id === suggestion.id) === undefined)
        {
            this.setState( prevState => ({ ...prevState, usersToBeShared: prevState.usersToBeShared.concat(suggestion)}));
        }
        
    }

    removeSharedUser (userToRemove) {
        this.setState( prevState => ({ ...prevState, usersToBeShared: prevState.usersToBeShared.filter(user => user.id !== userToRemove.id)}));
    }

    addSharedUserByEmail (email) {
        if (this.state.suggestions.length === 1){
            this.addSharedUser(this.state.suggestions[0]);
        } else if (EmailValidator.validate(email.trim())) {
            if (this.state.sharedEmails.indexOf(email.trim()) === -1) { 
                if(this.state.userEmailsToBeShared.find(email => email === email.trim()) === undefined)
                {
                    this.setState( prevState => ({ ...prevState, userEmailsToBeShared: prevState.userEmailsToBeShared.concat(email.trim())}));
                }
            }
        }
    }

    removeSharedUserByEmail (emailToRemove) {
        this.setState( prevState => ({ ...prevState, userEmailsToBeShared: prevState.userEmailsToBeShared.filter(email => email.id !== emailToRemove.id)}));
    }

    resetSharedUsersState () {
        this.setState({
            disableSummaryShareBtn: false,
            sharedUsersCount: 0,
            sharedEmailCount: 0,
            sharedEmails: [],
            sharedUsers: [],
            newSharedUserCount: 0,
            usersToBeShared: [],
            userEmailsToBeShared: [],
            showTOCDownloadBtn: true,
            showTitleDownloadBtn: true,
            showCoverDownloadBtn: true,

        });
    }

    onClose () {
        this.resetShareDownloadProps();
        this.props.close();
        this.resetSharedUsersState();
        this.setState({collectionCreator: undefined});
    }

    onAfterOpen () {
        if (this.props.collection.resourceIds && !this.props.collection.resourceIds.length > 0) {
            this.setState({showTOCDownloadBtn: false, showTitleDownloadBtn: false, showCoverDownloadBtn: false});
        }
        
        this.fetchCoverPageLink().then((response) => {
            if (response && response.data && response.data.pdfUrl) { 
                this.setState({
                    mergedCoverPDfEpsUrl: response.data.pdfUrl,
                    showCoverDownloadBtn: true,

                });
            } else {
                this.setState({showCoverDownloadBtn: false});
            }
        }).catch(response => {this.setState({showCoverDownloadBtn: false});});
        this.fetchTOCPageLink().then((response) => {
            if (response && response.data && response.data.pdfUrl) { 
                this.setState({
                    tocPagePdfEpsUrl: response.data.pdfUrl,
                    showTOCDownloadBtn: true,
                });
            } else {
                this.setState({showTOCDownloadBtn: false});
            }
        }).catch(response => {this.setState({showTOCDownloadBtn: false});});
        this.fetchTitlePageLink().then((response) => {
            if (response && response.data && response.data.pdfUrl) { 
                this.setState({
                    titlePageEpsPdfUrl: response.data.pdfUrl,
                    showTitleDownloadBtn: true,
                });
            } else {
                this.setState({showTitleDownloadBtn: false});
            }
        }).catch(response => {this.setState({showTitleDownloadBtn: false});});

        this.props.isDefaultOptionTOC ? this.setState({selected: this.shareableOptions[1]}) : this.setState({selected: this.shareableOptions[0]});

        if (this.props.collection && this.props.collection.creator && this.props.user.id !== this.props.collection.creator) {
            this.fetchingSharedUsersAndCreator(this.props.collection.collectionId, this.props.collection.creator);
        } else {
            this.setState({isSharedUsersBeingFetched : true});
            const fetchSharedUsers = Promise.all([axiosClient.get(formatUrl(config.collectionService.baseUrl, config.collectionService.routes.sharedUsers, {collectionId : this.props.collection.collectionId}))
                , axiosClient.get(formatUrl(config.collectionService.baseUrl, config.collectionService.routes.sharedUserEmails, {collectionId : this.props.collection.collectionId}))
            ]);
            fetchSharedUsers.then( response => this.setState({isSharedUsersBeingFetched : false, sharedUsers: response[0].data, sharedUsersCount: response[0].data.length, sharedEmails: response[1].data, sharedEmailCount: response[1].data.length,  usersToBeShared : response[0].data})).catch(() => this.setState({isSharedUsersBeingFetched : false}));
        }
    }

    fetchingSharedUsersAndCreator(collectionId, creatorId) {
        this.setState({isSharedUsersBeingFetched : true});
        const promises = [];
        if (creatorId !== undefined && creatorId !== '' && creatorId !== null) {
            const creatorPromise = axiosClient.get(formatUrl(config.identity.baseUrl, config.identity.routes.userById, {userId: creatorId}));
            promises.push(creatorPromise);
        }
        if (collectionId){
            const sharedUsersPromise = axiosClient.get(formatUrl(config.collectionService.baseUrl, config.collectionService.routes.sharedUsers, {collectionId : collectionId}));
            const sharedUsersEmailPromise = axiosClient.get(formatUrl(config.collectionService.baseUrl, config.collectionService.routes.sharedUserEmails, {collectionId : collectionId}));
            promises.push(sharedUsersPromise);
            promises.push(sharedUsersEmailPromise);
        }
    
        if (promises.length > 0){
            Promise.all(promises).then(response => {
                this.setState({isSharedUsersBeingFetched : false, collectionCreator: response[0].data, sharedUsers: response[1].data,  sharedUsersCount: response[1].data.length, sharedEmails: response[2].data ,sharedEmailCount: response[2].data.length, usersToBeShared : response[1].data});
            }).catch(() => this.setState({isSharedUsersBeingFetched : false}));
        }
    }

    resetShareDownloadProps () {
        clearInterval(this.titleLinkTimeout);
        clearInterval(this.tocLinkTimeout);
        clearInterval(this.coverLinkTimeout);
        window.URL.revokeObjectURL(this.state.mergedCoverUrl);
        window.URL.revokeObjectURL(this.state.tocPageUrl);
        window.URL.revokeObjectURL(this.state.titlePageUrl);
        this.setState({
            titleProgressBarValue: 0,
            tocProgressBarValue: 0,
            coverProgressBarValue: 0,
            showCoverProgressBar: false,
            showTOCProgressBar: false,
            showTitleProgressBar: false,
            mergedCoverUrl: '',
            tocPageUrl: '',
            titlePageUrl: '',
            mergedCoverPDfEpsUrl: '',
            tocPagePdfEpsUrl: '',
            titlePageEpsPdfUrl: '',
            showTOCDownloadBtn: true,
            showTitleDownloadBtn: true,
            showCoverDownloadBtn: true,
        });
    }

    shareCollection () {
        const userIds = this.state.usersToBeShared.map(user => { return user.id; });
        const preUserIds = this.state.sharedUsers.map(user => { return user.id; });
        if (preUserIds.length > userIds.length) {
            this.addedUsers = userIds.filter((userId) => !preUserIds.includes(userId));
        }
        this.props.shareCollection({
            collectionId: this.props.collection.collectionId,
            userIds: userIds,
            emails: this.state.userEmailsToBeShared,
            message: this.message.value.trim(),
            newCount: this.addedUsers.length + this.state.userEmailsToBeShared.length
        });
        this.resetSharedUsersState();
    }

    getCreatorAndSharedUsers(){
        if (this.state.isSharedUsersBeingFetched){
            return <div>
                <Spinner id="ShareComponentShareUserSpinner" active={true} data ={this.dataForSpinner} />
            </div>;
        }
        const comps = [];
        comps.push(this.getCreator());
        comps.push(this.getSharedUsers(this.state.usersToBeShared));
        return comps;
    }

    getPendingSharedEmails(){
        if (this.state.isSharedUsersBeingFetched){
            return <div>
                <Spinner id="ShareComponentPendingShareUserSpinner" active={true} data ={this.dataForSpinner} />
            </div>;
        }
        const comps = [];
        comps.push(this.getPendingSharedUserEmails(this.state.sharedEmails));
        return comps;
    }

    getCreator(){
        const comps = [];       
        if (this.state.collectionCreator && this.props.user.id !== this.state.collectionCreator.id && this.state.collectionCreator.email) {
            const displayCreatorData = `${this.state.collectionCreator.email} (${this.state.collectionCreator.username})`;
            comps.push(
                <div key={'creator'}>
                    <span>{displayCreatorData}</span>
                </div>);
        }
        return comps;
    }
    getSharedUsers (sharedUsers) {
        const comps = [];
        const userId = this.props.collection.creator;
        if (sharedUsers) {
            sharedUsers.forEach((user, index) => {
                const userName = user.username ? `(${user.username}) ` : ' ';
                const displayCreatorData = `${user.email} ${userName}`;
                comps.push(<div key={index}><span>{displayCreatorData}</span>{
                    (userId === this.props.user.id || user.id === this.props.user.id)
                    && <a onClick={() => this.removeSharedUser(user)}><span><Svg
                        svgString="item-remove-18"></Svg></span></a>}
                </div>);
            });
        }
        return comps;
    }

    getSharedUserEmails (emails) {
        const comps = [];
        emails.forEach((email, index) => {
            comps.push(<div key={index}><span>{email + ' '}</span><a
                onClick={() => this.removeSharedUserByEmail(email)}><span><Svg
                    svgString="item-remove-18"></Svg></span></a>
            </div>);
        });
        return comps;
    }

    getPendingSharedUserEmails (emails) {
        const comps = [];
        emails.forEach((email, index) => {
            comps.push(<div key={index}><span>{email + ' '}</span></div>);
        });
        return comps;
    }

    filterResults (results) {
        const {collection, user} = this.props;
        const sharedUserIds = this.state.usersToBeShared.map(user => user.id);
        this.setState({suggestions: results});
        return results.filter(result => {
            return (![collection.creator].concat(sharedUserIds).includes(result.id));
        });
    }

    getCourseName (cover) {
        const dashboardCourse = this.props.collection.course;
        const setCourse = dashboardCourse && dashboardCourse !== '--' ? dashboardCourse : this.props.collection.title.substring(0, 15);
        return Object.keys(this.props.collection.collectionCourseInformation).length && this.props.collection.collectionCourseInformation.courseNo
            ? this.props.collection.collectionCourseInformation.courseNo.replace(/ /g, '_') + cover
            : setCourse.replace(/ /g, '_') + cover;
    }

    getTOCDownloadPdf () {
        this.setState({tocProgressBarValue: 0, showTOCProgressBar: true});
        if (this.tocLinkTimeout) {
            clearInterval(this.tocLinkTimeout);
        }
        this.tocLinkTimeout = setInterval(() => {
            if (this.state.tocProgressBarValue < 90) {
                this.setState({tocProgressBarValue: this.state.tocProgressBarValue + 5});
            }           
        }, 2000);
        if (this.state.tocPagePdfEpsUrl   && this.state.tocPagePdfEpsUrl !== '') {
            fetch(this.state.tocPagePdfEpsUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                },
            }).then(response => response.blob()).then(blob => {
                clearInterval(this.tocLinkTimeout);
                this.setState({
                    tocPageUrl: window.URL.createObjectURL(new Blob([blob], { type: "application/octet-stream" })),
                    tocProgressBarValue: 100,
                    showTOCProgressBar: false
                });
                this.TOCRef.current.click();
            });
        }
    }

    fetchTOCPageLink () {
        return axiosClient.get(formatUrl(config.bookBuildService.baseUrl, config.bookBuildService.routes.buildPdf, {collectionId : this.props.collection.collectionId, type : 'TOCPage'}));
    }

    getTitleDownloadPdf () {
        this.setState({titleProgressBarValue: 0, showTitleProgressBar: true});
        if (this.titleLinkTimeout) {
            clearInterval(this.titleLinkTimeout);
        }
        this.titleLinkTimeout = setInterval(() => {
            if (this.state.titleProgressBarValue < 90) {
                this.setState({titleProgressBarValue: this.state.titleProgressBarValue + 5});
            }
        }, 2000);
        if (this.state.titlePageEpsPdfUrl  && this.state.titlePageEpsPdfUrl !== '') {
            fetch(this.state.titlePageEpsPdfUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                },
            }).then(response => response.blob()).then(blob => {
                clearInterval(this.titleLinkTimeout);
                this.setState({
                    titlePageUrl: window.URL.createObjectURL(new Blob([blob], { type: "application/octet-stream" })),
                    titleProgressBarValue: 100,
                    showTitleProgressBar: false
                });
                this.titleRef.current.click();
            });
        }
    }

    fetchTitlePageLink () {
        return axiosClient.get(formatUrl(config.bookBuildService.baseUrl, config.bookBuildService.routes.buildPdf, {collectionId : this.props.collection.collectionId, type : 'TitlePage'}));
    }

    getCoverDownloadPdf () {
        this.setState({coverProgressBarValue: 0, showCoverProgressBar: true});
        this.coverLinkTimeout = setInterval(() => {
            if (this.state.coverProgressBarValue < 90) {
                this.setState({coverProgressBarValue: this.state.coverProgressBarValue + 5});
            }
        }, 2000);
        if (this.state.mergedCoverPDfEpsUrl && this.state.mergedCoverPDfEpsUrl !== '') {
            fetch(this.state.mergedCoverPDfEpsUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                },
            }).then(response => response.blob()).then(blob => {
                clearInterval(this.coverLinkTimeout);
                this.setState({
                    mergedCoverUrl: window.URL.createObjectURL(new Blob([blob], { type: "application/octet-stream" })),
                    coverProgressBarValue: 100,
                    showCoverProgressBar: false
                });
                this.coverRef.current.click();              
            });
        }
    }

    fetchCoverPageLink () {
        return axiosClient.get(formatUrl(config.bookBuildService.baseUrl, config.bookBuildService.routes.buildPdf, {collectionId : this.props.collection.collectionId, type : 'MergedCoverPage'}));
    }

    getNewShareUsers () {
        this.userIds = this.state.usersToBeShared.map(user => { return user.id; });
        this.preUserIds = this.state.sharedUsers.map(user => { return user.id; });
        this.addedUsers = this.userIds.filter((userId) => !this.preUserIds.includes(userId));
        return !(this.addedUsers.length !== 0 || this.userIds.length < this.preUserIds.length);
    }

    render () {
        const theme = {
            container: 'react-autosuggest__container',
            containerOpen: 'react-autosuggest__container--open',
            input: 'pe-textInput--basic',
            inputOpen: 'react-autosuggest__input--open',
            inputFocused: 'react-autosuggest__input--focused',
            suggestionsContainer: 'react-autosuggest__suggestions-container',
            suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
            suggestionsList: 'react-autosuggest__suggestions-list',
            suggestion: 'react-autosuggest__suggestion',
            suggestionFirst: 'react-autosuggest__suggestion--first',
            suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
            sectionContainer: 'react-autosuggest__section-container',
            sectionContainerFirst: 'react-autosuggest__section-container--first',
            sectionTitle: 'react-autosuggest__section-title'
        };
        const { user } = this.props;
        return (
            <div>
                <Modal name="Share Collection" isOpen={this.props.isOpen} onClose={() => this.onClose()}
                    onAfterOpen={() => this.onAfterOpen()} onBlur={() => this.resetContent()}>
                    <div className="home-modal-content collection-share-modal">
                        <h1>Share Collection</h1>
                        <div className="home-modal-body">
                            <div>
                                <div className="hide-in-digital-collection">
                                    <div className="selection-label">
                                        <label className="pe-textLabelInput__label">What would you like to
                                            share?</label>
                                    </div>
                                    <SelectDropDown
                                        name="shareOptionDropDown"
                                        options={this.shareableOptions}
                                        default={this.state.selected}
                                        onChange={this.shareContextChange}/>
                                </div>
                                {this.state.selected !== undefined && this.state.selected.value === 'COMPLETE' && <div className="entire-collection-part">
                                    <div className="mail-list-label">
                                        <label className="pe-textLabelInput__label">Who would you like to share it with?
                                            Enter
                                            email addresses.</label>
                                    </div>
                                    <AutoSearch characterLimit={3}
                                        filterResults={this.filterResults}
                                        onInputEntered={email => this.addSharedUserByEmail(email)}
                                        onSuggestionSelected={suggestion => this.addSharedUser(suggestion)}
                                        placeHolder={'Email address'}
                                        renderSuggestion={this.renderSuggestion}
                                        searchUrl={this.getSearchUrl()}
                                        theme={theme}
                                        userRoles={user.userRoles}
                                        currentUser={user}/>
                                    <div className="shared-with-container">
                                        {(this.state.userEmailsToBeShared.length !== 0 || (this.state.collectionCreator && this.props.user.id !== this.state.collectionCreator.id && this.state.collectionCreator.email)
                                        || this.state.usersToBeShared.length !== 0) && <label>Currently shared with:</label>}
                                        {this.getCreatorAndSharedUsers()}
                                        {this.getSharedUserEmails(this.state.userEmailsToBeShared)}
                                    </div>
                                    <div className="shared-with-container">
                                        {this.state.sharedEmails.length !== 0 && <label>Pending Shares:</label>}
                                        {this.getPendingSharedEmails()}
                                    </div>
                                    <div className="message-label"><label className="pe-textLabelInput__label">The
                                        message below
                                        will be sent with your invitation to share this Collection.</label></div>
                                    <div><textarea className="pe-multiLineText message-box"
                                        ref={input => this.message = input}
                                        placeholder={(this.props.user) ? `${this.props.user.firstName} ${this.props.user.lastName} has shared the collection "${this.props.collection.title}" with you.` : ''}/>
                                    </div>
                                </div>}
                                {this.state.selected !== undefined && this.state.selected.value === 'TOC' && <div className="cover-toc-container">
                                    <div className="mail-list-label">
                                        <label className="pe-textLabelInput__label">
                                        Select which PDF file(s) to download. They can be added as an attachment to your email message.
                                        </label>
                                    </div>
                                    <div className="download-container">
                                        <span>
                                            {this.getCourseName('_Cover.pdf')}
                                            <div>
                                                {this.state.showCoverProgressBar ?
                                                    <ProgressBar min={0} max={100} value={this.state.coverProgressBarValue}
                                                        type="animated" alignLabel="left" labelText="Generating PDF…"
                                                        id="cover-progress-bar"/> : ''}
                                            </div>
                                        </span>
                                        <div className="pdf-download">
                                            <a className={this.state.showCoverDownloadBtn ? 'pe-btn' : 'pe-btn download-btn-disabled'}
                                                onClick={event => {
                                                    event.preventDefault();
                                                    this.getCoverDownloadPdf();
                                                }}
                                            >
                                                Download Cover
                                            </a>
                                            <a id="downloadCoverPDF" ref={this.coverRef} hidden={true} href={this.state.mergedCoverUrl}
                                                download={this.getCourseName('_Cover.pdf')}></a>
                                        </div>
                                    </div>
                                    <div className="download-container">
                                        <span>
                                            {this.getCourseName('_TOC.pdf')}
                                            <div>
                                                {this.state.showTOCProgressBar ?
                                                    <ProgressBar min={0} max={100} value={this.state.tocProgressBarValue}
                                                        type="animated" alignLabel="left" labelText="Generating PDF…"
                                                        id="toc-progress-bar"/> : ''}
                                            </div>
                                        </span>
                                        <div className="pdf-download">
                                            <a className={this.state.showTOCDownloadBtn ? 'pe-btn' : 'pe-btn download-btn-disabled'}
                                                onClick={event => {
                                                    event.preventDefault();
                                                    this.getTOCDownloadPdf();
                                                }}
                                            >
                                                Download Table of Contents
                                            </a>
                                            <a id="downloadTOCPDF" ref={this.TOCRef} hidden={true} href={this.state.tocPageUrl}
                                                download={this.getCourseName('_TOC.pdf')}></a>
                                        </div>
                                    </div>
                                    <div className="download-container">
                                        <span>
                                            {this.getCourseName('_TitlePage.pdf')}
                                            <div>
                                                {this.state.showTitleProgressBar ?
                                                    <ProgressBar min={0} max={100} value={this.state.titleProgressBarValue}
                                                        type="animated" alignLabel="left" labelText="Generating PDF…"
                                                        id="title-progress-bar"/> : ''}
                                            </div>
                                        </span>
                                        <div className="pdf-download">
                                            <a className={this.state.showTitleDownloadBtn ? 'pe-btn' : 'pe-btn download-btn-disabled'}
                                                onClick={event => {
                                                    event.preventDefault();
                                                    this.getTitleDownloadPdf();
                                                }}
                                            >
                                                Download Title Page
                                            </a>
                                            <a id="downloadTitlePDF" ref={this.titleRef} hidden={true} href={this.state.titlePageUrl}
                                                download={this.getCourseName('_TitlePage.pdf')}></a>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            {this.state.selected !== undefined && this.state.selected.value === 'COMPLETE' && <div className="home-modal-footer">
                                <button className="pe-btn--btn_large btn-cancel" onClick={() => this.onClose()}>Cancel
                                </button>
                                {this.disabled = this.getNewShareUsers() && this.state.userEmailsToBeShared.length === 0}
                                <button
                                    className={'pe-btn__primary--btn_large btn-action'.concat(this.disabled ? ' share-btn-disable' : '')}
                                    onClick={() => this.shareCollection()} disabled={this.disabled}>Share{this.state.sharedUsersCount + this.state.sharedEmailCount > 0 ?
                                        <span> ({this.state.sharedUsersCount + this.state.sharedEmailCount})</span> : ''}
                                </button>
                            </div>}
                            {this.state.selected !== undefined && this.state.selected.value === 'TOC' && <div className="home-modal-footer">
                                <button className="pe-btn--btn_large btn-cancel" onClick={() => this.onClose()}>Cancel
                                </button>
                                {this.disabled = (!(this.state.usersToBeShared.length + this.state.userEmailsToBeShared.length + this.state.sharedUsersCount > 0))}
                                <button
                                    className={'pe-btn__primary--btn_large btn-action'}
                                    onClick={() => this.onClose()}>Done
                                </button>
                            </div>}
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default ShareComponent;



// WEBPACK FOOTER //
// ./src/components/widgets/shareModal/ShareComponent.js